module.exports = __webpack_public_path__ + "img/walletconnect-banner.e1cb8d21.png";